module.exports = __webpack_public_path__ + "media/images/footer_logo_sp-7066b094a58b8f9b8d83ef78b7f9407c.svg";